import { Anchor, Box, Button, Text, Tooltip } from "@mantine/core";
import { IconFileDescription } from "@tabler/icons-react";

export const VIEW_RESUME_LABEL = "View resume";
export const NO_RESUME_LABEL = "No resume";

type ResumeLinkProps = {
  url: string | null | undefined;
  /** button = filled action; link = inline text link; icon = icon-only with tooltip */
  variant?: "button" | "link" | "icon";
  size?: "xs" | "sm" | "md";
  iconSize?: string;
  label?: string;
  buttonVariant?: "light" | "default";
  showWhenEmpty?: boolean;
};

const DEFAULT_RESUME_ICON_SIZE = "var(--axio-unit-16)";

export function ResumeLink({
  url,
  variant = "button",
  size = "sm",
  iconSize = DEFAULT_RESUME_ICON_SIZE,
  label = VIEW_RESUME_LABEL,
  buttonVariant = "light",
  showWhenEmpty = false,
}: ResumeLinkProps) {
  if (variant === "icon") {
    if (!url) {
      return (
        <Tooltip label={NO_RESUME_LABEL}>
          <Box component="span" display="inline-flex">
            <Anchor
              component="button"
              type="button"
              size={size}
              c="dimmed"
              display="inline-flex"
              aria-label={NO_RESUME_LABEL}
              disabled
            >
              <IconFileDescription size={iconSize} />
            </Anchor>
          </Box>
        </Tooltip>
      );
    }
    return (
      <Tooltip label={label}>
        <Anchor
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          size={size}
          display="inline-flex"
          aria-label={label}
        >
          <IconFileDescription size={iconSize} />
        </Anchor>
      </Tooltip>
    );
  }

  if (!url) {
    if (variant === "link") {
      return (
        <Text size={size} c="dimmed">
          {NO_RESUME_LABEL}
        </Text>
      );
    }
    if (variant === "button" && showWhenEmpty) {
      return (
        <Button variant={buttonVariant} size={size} disabled>
          {NO_RESUME_LABEL}
        </Button>
      );
    }
    return null;
  }

  if (variant === "link") {
    return (
      <Anchor href={url} target="_blank" rel="noopener noreferrer" size={size}>
        {label}
      </Anchor>
    );
  }

  return (
    <Button
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant={buttonVariant}
      size={size}
      leftSection={<IconFileDescription size="var(--axio-unit-16)" />}
    >
      {label}
    </Button>
  );
}
